import {ACCEPTED_TYPES} from 'common/src/components/DigitalAssetsTable/components/DAMCreate/DAMCreate';
import parseFileName from './parseFileName';

export default function getFileFromLink(url: string, fileName: string) {
  return fetch(url)
    .then((res) => res.blob())
    .then(
      (blob) =>
        new File([blob], fileName, {
          type: ACCEPTED_TYPES[parseFileName(fileName).fileExtension],
        }),
    );
}
